import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import useSWRMutation from 'swr/mutation'
import { Button, Form, Popconfirm, Typography } from 'antd'
import { postFetcher } from '@BUP/services/Axios'
import { ComplaintFormInputs } from '@BUP/components/complaint/form-inputs'
import { useState } from 'react'

export function ComplaintForm () {
  const i18n = useTranslation()
  const [form] = Form.useForm()
  const { trigger, isMutating } = useSWRMutation('/current-enrollment/complaints', postFetcher)
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)

  const handleOnFinish = async values => {
    try {
      const complaint = await trigger(values)
      if (complaint) {
        form.resetFields()
        navigate(`/logbook/complaints/${complaint.id}`)
      }
    } catch (error) {
      console.log('Error', error) // TODO: handler error
    }
  }
  const handleOnFinishFailed = errorInfo => console.log('Failed:', errorInfo) // TODO: handle failure
  const showPopconfirm = () => form.validateFields().then(() => setOpen(true)).catch(() => {})
  const handleOnConfirm = () => form.submit()
  const handleOnCancel = () => setOpen(false)

  return (
    <Form
      layout='vertical'
      form={form}
      onFinish={handleOnFinish}
      onFinishFailed={handleOnFinishFailed}
      disabled={isMutating}
    >
      <ComplaintFormInputs form={form} />
      <Form.Item>
        <Popconfirm
          onCancel={handleOnCancel}
          onConfirm={handleOnConfirm}
          okButtonProps={{ loading: isMutating }}
          okText={i18n.t('common.resources.complaint.actions.confirm.ok')}
          cancelText={i18n.t('common.resources.complaint.actions.confirm.cancel')}
          open={open}
          title={<><Typography.Paragraph strong>{i18n.t('common.resources.complaint.actions.confirm.title')}</Typography.Paragraph><Typography.Paragraph>{i18n.t('common.resources.complaint.actions.confirm.content')}</Typography.Paragraph></>}
        >
          <Button type='primary' onClick={showPopconfirm}>{i18n.t('common.resources.generic.actions.create.submit')}</Button>
        </Popconfirm>
      </Form.Item>
    </Form>
  )
}
